import { CustomButton } from "../global/CustomButton"
import "./messageResultBox.css"

export function MessageResultBox({ messageSuccess, setMessageSuccess }) {
    const messageSuccessTitle = "Success"
    const messageSuccessText = "Your message has been sent successfully. We will contact you very soon."
    const messageFailureTitle = "Error"
    const messageFailureText = "Failed to send message. Try again."

    return (
        <div className="message-result-container d-flex cntr">
            <div className="message-result-box rounded-1 d-flex flex-column align-items-center justify-content-between py-5 px-3">
                <div className="text-center">
                    {
                        messageSuccess === true ?
                            <>
                                <h1>{messageSuccessTitle}</h1>
                                <p>{messageSuccessText}</p>
                            </>
                            : messageSuccess === false ?
                            <>
                                <h1>{messageFailureTitle}</h1>
                                <p>{messageFailureText}</p>
                            </>
                            : null
                    }
                </div>
                
                <CustomButton
                    color="primary"
                    text="OK"
                    btnFunction={() => setMessageSuccess(null)}
                />
            </div>
        </div>
    )
}